import './Doctors.css';
import React, { useEffect, useContext } from 'react';
import progressContext from '../../context/loading/progresscontext';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import CtaBand from '../home/ctaband/CtaBand';

function Doctors() {
  const { setProgress } = useContext(progressContext);

  useEffect(() => {
    if (setProgress) {
      setProgress(70);
      setTimeout(() => {
        setProgress(100);
      }, 100);
    }
  }, [setProgress]);

  return (
    <main className="doctors-page">
      <Breadcrumb
        pageName="Our Doctors"
        bgImage="/img/uplaods/rad.jpg"
        path={[
          { label: 'Home', href: '/' },
          { label: 'Our Doctors' }
        ]}
      />

      <section className="band tint" id="doctors">
        <div className="wrap">
          <p className="eyebrow">Medical leadership</p>
          <h2 className="h-sec">Meet the team.</h2>
          <p className="lede" style={{ marginTop: '20px' }}>
            Dr. Nishita Rao and Dr. Mahesh B Rao, the co-founders of our institution, bring decades of combined clinical expertise and patient-centred compassion to Malleswaram.
          </p>

          <div className="docs">
            <article className="doc">
              <div className="portrait">
                <img
                  src="/img/dr-nishita-rao.webp"
                  alt="Dr. Nishita Rao"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/uplaods/dr-nishita-rao.webp";
                  }}
                />
              </div>
              <div>
                <h3>Dr. Nishita Rao</h3>
                <p className="role">Obstetrician &amp; Gynaecologist</p>
                <p className="quals">
                  MBBS, MS &mdash; Obstetrics &amp; Gynaecology<br />
                  <em>18 years of experience</em>
                </p>
                <p className="bio">
                  Dr. Nishita Rao specialises in obstetrics and gynaecology, focusing on comprehensive care for women throughout their pregnancy journey. She is widely recognised for her patient-centric approach and a 90% success rate in normal deliveries, addressing a broad spectrum of women's health needs from puberty to menopause.
                </p>
              </div>
            </article>

            <article className="doc">
              <div className="portrait">
                <img
                  src="/img/dr-mahesh-rao.webp"
                  alt="Dr. Mahesh B Rao"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/uplaods/dr-mahesh-rao.webp";
                  }}
                />
              </div>
              <div>
                <h3>Dr. Mahesh B Rao</h3>
                <p className="role">Paediatrician</p>
                <p className="quals">
                  Child Specialist, Paediatric Medicine<br />
                  <em>21 years of experience</em>
                </p>
                <p className="bio">
                  Dr. Mahesh is a highly skilled paediatrician dedicated to compassionate care for children. He oversees our child care and neonatal services, ensuring every child receives attentive, evidence-based care from newborn screening through adolescent milestones.
                </p>
              </div>
            </article>
          </div>

          <div className="soft" style={{ marginTop: '48px', padding: '36px', borderRadius: '2px', border: '1px solid var(--sage-line)' }}>
            <p className="eyebrow">Our Approach to Normal Delivery</p>
            <h3 style={{ fontFamily: 'var(--display)', fontSize: '1.6rem', fontWeight: 400, marginTop: '8px', color: 'var(--ink)' }}>Safe, patient-centred birthing with minimal intervention.</h3>
            <p style={{ marginTop: '16px', fontSize: '15.5px', lineHeight: '1.65', color: 'var(--muted)' }}>
              Under the expert care of Dr. Nishita Rao, we prioritize safe vaginal births with personalised birth plans tailored to your values and preferences. We emphasize evidence-based practices, compassionate reassurance, and continuous 24/7 monitoring so both mother and newborn receive optimal, respectful care.
            </p>
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}

export default Doctors;